import DataLoader from "dataloader"
import { useQuery } from "@tanstack/react-query"
import { getSimplePersonsByIds, SimplePerson } from "@/orval/gen"
import { useQueryClient } from "@tanstack/react-query"
const loader = new DataLoader(
  async (keys: readonly number[]) => {
    const results = await getSimplePersonsByIds({
      ids: [...keys],
    })
    return keys.map((key) => results?.find((x) => x.personId === key) ?? null)
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedSimplePerson(key?: number) {
  return useQuery({
    queryKey: getSimplePersonQueryKey(key!),
    queryFn: () => loader.load(key!),
    enabled: key !== undefined,
  })
}

/**
 * Fetch a single simple person by ID (using the same dataloader).
 * Used for fetching selected items in infinite selects.
 */
export async function fetchSimplePersonById(
  personId: string | number
): Promise<SimplePerson | null> {
  const numPersonId =
    typeof personId === "string" ? parseInt(personId, 10) : personId
  return loader.load(numPersonId)
}

export function getSimplePersonQueryKey(personId: number) {
  return ["SimplePerson", personId]
}

export function useRemoveSimplePersonFromCache() {
  const queryClient = useQueryClient()
  return (personId: number) => {
    loader.clear(personId)
    queryClient.invalidateQueries({
      queryKey: getSimplePersonQueryKey(personId),
    })
  }
}
